<template>
  <div class="my-2 my-md-0">
    <div v-if="hor.marcacao.combo && !hor.marcacao.combo.st_sigla" class="small text-muted">
      {{ hor.marcacao.combo.st_procedimento }}
    </div>
    <div v-if="hor.marcacao.infusao && hor.marcacao.infusao.st_titulo" class="small text-muted">
      {{ hor.marcacao.infusao.st_titulo }}
      <span class="ml-2" v-if="hor.marcacao.in_qt_dia && hor.marcacao.in_qt_ciclo" title="Ciclo / Dia">
        C{{ hor.marcacao.in_qt_ciclo }} / D{{ hor.marcacao.in_qt_dia }}
      </span>
    </div>
    <div v-else-if="hor.marcacao.marcacao && hor.marcacao.marcacao.infusao && hor.marcacao.marcacao.infusao.st_titulo" class="small text-muted">
      {{ hor.marcacao.marcacao.infusao.st_titulo }}
    </div>
    <div v-else-if="hor.marcacao.receita && hor.marcacao.receita.titulo" class="small text-muted">
      {{ hor.marcacao.receita.titulo }}
      <span class="ml-2" v-if="hor.marcacao.receita.in_qt_dia && hor.marcacao.receita.in_qt_ciclo" title="Ciclo / Dia">
        C{{ hor.marcacao.receita.in_qt_ciclo }} / D{{ hor.marcacao.receita.in_qt_dia }}
      </span>
    </div>
    <div class="d-flex justify-content-between">
      <div :class="truncate ? 'text-truncate' : ''">
        <template v-if="lab && hor.marcacao.atendimento">
          <span class="badge badge-secondary mr-1">
            {{ hor.marcacao.atendimento.atendimento_procedimentos.length }}
          </span>
          <template v-for="(atp, iax) in hor.marcacao.atendimento.atendimento_procedimentos">
            <span :key="iax" v-show="!limite_badges || iax < limite_badges || expandir_badges" v-if="true"
              class="badge badge-pill mr-1" :class="'badge-' + ( ( atp.laudo && atp.laudo.status_laudo ) ? atp.laudo.status_laudo.st_color : 'success' )"
              :title="( ( atp.laudo && atp.laudo.status_laudo ) ? atp.laudo.status_laudo.st_status_laudo : '' )">
              {{ atp.procedimento.st_sigla ? atp.procedimento.st_sigla : atp.procedimento.st_procedimento }}
              <i class="fa-solid fa-circle-exclamation text-danger" v-if="atp.fl_urgente" title="Urgente"></i>
            </span>
          </template>
          <a href="#" @click.prevent="expandir_badges = !expandir_badges" v-if="limite_badges && limite_badges < hor.marcacao.atendimento.atendimento_procedimentos.length">
            <span class="badge badge-pill badge-secondary mr-1">
              <i class="fa-solid fa-arrow-left" v-if="expandir_badges"></i>
              <i class="fa-solid fa-ellipsis" v-else></i>
            </span>
          </a>
        </template>
        <template v-else>
          <span :data-toggle="total > 100 ? 'tooltip2' : 'tooltip'" data-placement="top" :title="proced_tooltip" data-html="true" :class="truncate ? 'text-nowrap' : ''">
            {{ hor.marcacao.procedimento.search }} 
            <span class="text-muted small ml-1" v-if="hor.marcacao.st_regiao">
              {{ hor.marcacao.st_regiao }}
            </span>
            <span class="text-muted small ml-1" v-else-if="hor.marcacao.nome_regiao_cd">
              {{ hor.marcacao.nome_regiao_cd }}
            </span>
          </span>
          <span v-if="hor.marcacao.combo && hor.marcacao.combo.st_sigla" class="badge badge-dark mr-1" :title="hor.marcacao.combo.st_procedimento">
            {{ hor.marcacao.combo.st_sigla }}
          </span>
        </template>

        <span
          class="badge badge-pill"
          :class="hor.marcacao.ch_tipo_consulta == 'R' ? 'badge-danger' 
            : ( hor.marcacao.ch_tipo_consulta == 'P' ? 'badge-info' : 'badge-warning' )"
          data-toggle2="tooltip"
          data-placement="top"
          :title="hor.marcacao.ch_tipo_consulta == 'I' ? 'Inicial' : ( 
                    hor.marcacao.ch_tipo_consulta == 'R' ? 'Revisão' : ( 
                    hor.marcacao.ch_tipo_consulta == 'S' ? 'Subsequente' : ( 
                    hor.marcacao.ch_tipo_consulta == 'P' ? 'Pré-Natal' : '' 
                    ) ) )"
          v-if="hor.marcacao && hor.marcacao.ch_tipo_consulta"
        >{{ hor.marcacao.ch_tipo_consulta }}</span>
        
        <a href="#" @click.prevent="exibir_info(
            ( hor.marcacao.nome_paciente ? hor.marcacao.nome_paciente + ': ' : '' ) + 
            hor.marcacao.outros_proc_lista, 'Procedimentos adicionais')"
          v-if="hor.marcacao && !hor.marcacao.id_atendimento && hor.marcacao.outros_proc">
          <span class="badge badge-pill badge-primary ml-1" :title="'Procedimentos adicionais: ' + hor.marcacao.outros_proc_lista">
            <i class="fa fa-plus" aria-hidden="true"></i>
            {{ hor.marcacao.outros_proc }}
          </span>
        </a>

        <a href="#" @click.prevent="exibir_info('Procedimentos: ' + lista_atend_procs, 'Procedimentos', hor.marcacao.id_atendimento)"
          v-else-if="hor.total_items && hor.total_items.qtde > 1">
          <span class="badge badge-pill badge-primary ml-1">
            <i class="fa fa-plus" aria-hidden="true"></i>
            {{ hor.total_items.qtde - 1 }}
          </span>
        </a>

        <a href="#" @click.prevent="exibir_info('Procedimentos: ' + lista_atend_procs, 'Procedimentos', hor.marcacao.id_atendimento)"
          v-else-if="hor.marcacao && hor.marcacao.id_atendimento && hor.marcacao.atendimento && hor.marcacao.atendimento.atendimento_procedimentos_count > 1">
          <span class="badge badge-pill badge-primary ml-1" :title="'Procedimentos: ' + lista_atend_procs">
            <i class="fa fa-plus" aria-hidden="true"></i>
            {{ hor.marcacao.atendimento.atendimento_procedimentos_count - 1 }}
          </span>
        </a>

        <span v-else-if="hor.marcacao && hor.marcacao.id_atendimento && hor.marcacao.atendimento && hor.marcacao.atendimento.atendimento_procedimentos_count === 0" title="Atendimento/Procedimento(s) cancelado(s)">
            <i class="fa-solid fa-circle-xmark text-danger"></i>
        </span>

        <span v-if="hor.marcacao && hor.marcacao.fl_repetir">
          <i class="fas fa-sync-alt ml-1"></i>
        </span>

        <!-- Outros procedimentos em execução -->
        <span v-if="hor.marcacao && hor.marcacao.atend_proc_laudos && hor.marcacao.atend_proc_laudos.length && hor.marcacao.atend_proc_laudos.length <= 5">
          <span class="badge badge-pill ml-1" :class="'badge-' + atp.laudo.status_laudo.st_color" 
            :title="atp.procedimento.st_procedimento + ' / ' + atp.laudo.status_laudo.search"
            v-for="(atp, ilx) in hor.marcacao.atend_proc_laudos" :key="ilx">
            {{ atp.procedimento.st_sigla }}
          </span>
        </span>
      </div>
      <div class="ml-2" v-if="showPrint">
        <az-float-panel
          classe="right"
          title="Observações"
          icon="fas fa-file-alt"
          v-if="hor.marcacao && hor.marcacao.st_observacoes"
        >
          <small class="lead">{{ hor.marcacao.st_observacoes }}</small>
        </az-float-panel>
      </div>
    </div>

    <div v-if="hor.marcacao.eqps && hor.marcacao.eqps.length" class="small text-muted">
      {{ hor.marcacao.eqps.map(eqp => eqp.equipamento.st_sigla ? eqp.equipamento.st_sigla : eqp.equipamento.st_equipamento ).join(', ') }}
    </div>
    
    <div>
      <span>
        <!--   -->
        <small v-if="hor.marcacao.medico && !lab" class="mr-1" :data-toggle="total > 100 ? 'tooltip2' : 'tooltip'" data-placement="top" data-html="true" :title="$util.nl2br(hor.marcacao.medico.st_assinatura)">
          {{ hor.marcacao.medico.search }} <span v-if="hor.marcacao.medico_comp"><br>{{ hor.marcacao.medico_comp.search }}</span>
        </small>
        <small v-if="hor.marcacao.unidade_operacao && hor.marcacao.unidade_operacao.st_sigla" 
          data-toggle="tooltip" data-placement="top"
          class="badge badge-light mr-1" :title="hor.marcacao.unidade_operacao.st_nome">
          {{ hor.marcacao.unidade_operacao.st_sigla }}
        </small>
        <small v-if="hor.marcacao.atendimento && hor.marcacao.atendimento.apoiado && hor.marcacao.atendimento.apoiado.st_sigla" 
          data-toggle="tooltip" data-placement="top"
          class="badge badge-dark mr-1" :title="hor.marcacao.atendimento.apoiado.search">
          {{ hor.marcacao.atendimento.apoiado.st_sigla }}
        </small>
        <small v-if="hor.local_nome" class="text-muted"> / {{ hor.local_nome }}</small>
        <small v-else-if="hor.marcacao.local"> / 
          <a href="#" @click.prevent="callback_filtrar(hor.marcacao.local.st_local)" v-if="callback_filtrar" class="card-link">
            {{ hor.marcacao.local.st_local }}
          </a>
          <span v-else class="text-muted">
            {{ hor.marcacao.local.st_local }}
          </span>

          <!-- && ( hor.marcacao.local.fl_coleta_dom || hor.marcacao.infusao ) -->
        </small>
      </span>
      <a href="#" @click.prevent="abrir_anexos(hor)" class="card-link m-0" v-if="!blockanexos">
        <span data-toggle2="tooltip" data-placement="top" title="Anexar Arquivos">
          <i class="fa fa-paperclip ml-2" aria-hidden="true" v-if="hor.marcacao && hor.marcacao.arquivos && hor.marcacao.arquivos.length"></i>
          <i class="fas fa-plus ml-2" v-else></i>
        </span>
      </a>
      <template v-if="hor.marcacao && ( hor.marcacao.doc_pre_atends_count || ( hor.marcacao.doc_pre_atends && hor.marcacao.doc_pre_atends.length ) )">
        <a href="#" @click.prevent="$emit('abrirpreatend', hor.marcacao)" class="card-link m-0">
          <span data-toggle="tooltip" data-placement="top" title="Questionário de Pré-Atendimento">
            <i class="fas fa-clipboard-check ml-2" aria-hidden="true"></i>
          </span>
        </a>
      </template>

      <span class="small text-muted ml-2" v-if="hor.marcacao && hor.marcacao.atendimento && hor.marcacao.atendimento.internacao && hor.marcacao.atendimento.internacao.local_momento" title="Sala de Procedimento.">
        {{ hor.marcacao.atendimento.internacao.local_momento.st_sigla 
            ? hor.marcacao.atendimento.internacao.local_momento.st_sigla 
            : hor.marcacao.atendimento.internacao.local_momento.st_local  }}
      </span>

      <span class="small text-muted ml-2" v-else-if="hor.marcacao && hor.marcacao.atendimento && hor.marcacao.atendimento.local_momento" title="Sala de Procedimento.">
        {{ hor.marcacao.atendimento.local_momento.st_sigla 
            ? hor.marcacao.atendimento.local_momento.st_sigla 
            : hor.marcacao.atendimento.local_momento.st_local  }}
      </span>
      
    </div>

    <div v-if="hor.total_items && hor.total_items.valor_total > 0">
      {{ $util.formatMoeda(hor.total_items.valor_total) }}
      <span class="text-muted" v-if="hor.marcacao && hor.marcacao.st_id_externo">
        <i class="fa fa-caret-right mx-1" aria-hidden="true"></i>
        {{ hor.marcacao.id_marcacao }} / 
        {{ hor.marcacao.st_id_externo }}
      </span>
      <slot name="pos-valor"></slot>
    </div>

    <div v-if="hor.marcacao && hor.marcacao.local && hor.marcacao.local.fl_coleta_dom && hor.marcacao.st_observacoes" class="mt-1 small text-muted">
      <span v-if="false">
        {{ hor.marcacao.local.st_local }}
        <i class="fa fa-caret-right mx-1" aria-hidden="true"></i>
      </span>
      <span v-if="hor.marcacao.st_observacoes">
        {{ hor.marcacao.st_observacoes }}
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import AzFloatPanel from "../../util/AzFloatPanel.vue";

export default {
  data() { 
    return { 
      limite_badges: 15, 
      expandir_badges: false
    }
  },

  props: {
    hor: { type: Object },
    showPrint: {
      type: Boolean,
      default: true
    },
    blockanexos: { 
      type: Boolean,
      default: false
    },
    truncate: { 
      default: false, 
    },
    total: { 
      default: 0, 
    },
    lab: { 
      default: false,
      type: Boolean, 
    },
    callback_filtrar: { 
      default: null, 
    }
  },

  components: {
    AzFloatPanel
  },

  computed: { 
    proced_tooltip: function () { 
      let tooltip = this.hor.marcacao.procedimento.st_procedimento;

      if ( this.hor.marcacao.procedimento.st_codigo_cbhpm ) { 
        tooltip += ( tooltip ?  '<br>' : '' ) + 'TUSS: ' + this.hor.marcacao.procedimento.st_codigo_cbhpm;
      }

      if ( this.hor.marcacao.procedimento.st_codigo_sus ) { 
        tooltip += ( tooltip ?  '<br>' : '' ) + 'SUS: ' + this.hor.marcacao.procedimento.st_codigo_sus;
      }

      return tooltip;
    },

    lista_atend_procs: function () { 
      if ( !this.hor || !this.hor.marcacao || !this.hor.marcacao.atendimento || !this.hor.marcacao.atendimento.atendimento_procedimentos )
        return "";

      return this.hor.marcacao.atendimento.atendimento_procedimentos.filter(item => item.procedimento)
        .map(item => item.procedimento.search)
        .join(', ');
    },

  },

  methods: { 
    exibir_info (texto, titulo = 'Atenção', id_atendimento = null) { 
      if ( id_atendimento ) { 
        this.$util.loadItem(this, { 
          service: 'atendimentos',
          parms: { 
            id: id_atendimento, 
            lista_proc: true, 
          }
        })
        .then(res => { 
          console.log('ATP', res);
          
          let separador = ( res.atendimento_procedimentos.length <= 10 ? '\n' : ', ' );

          let agrupados = _.groupBy(res.atendimento_procedimentos, item => item.medico ? item.medico.search : '');

          let lista = '#' + id_atendimento + '\n' 
            + _.map(agrupados, (item, key) => { 
              return ( key ? key : ( res.medico ? res.medico.search : '' ) ) + ': \n' + item.map(subitem => '- ' + subitem.procedimento.search).join(separador);
            }).join('\n \n');
          
          /*
          res.atendimento_procedimentos.map(item => { 
              return item.procedimento.search + ( item.medico ? '\n > ' + item.medico.search + '\n' : '' );
          }).join(separador);
          */

          this.exibir_info(lista, 'Procedimentos');
        });

        texto = 'Carregando...';
      }

      this.$toast.add({
        severity: "info",
        summary: titulo,
        detail: texto,
        life: ( id_atendimento ? 3000 : 20000 )
      });
    },

    abrir_anexos (hor) { 
      if ( this.$store.state.loading ) 
        return; 

      this.$emit('abriranexos', hor.marcacao);
    }
  }

}
</script>